export default function PricingSection() {
  return (
    <section id="pricing" className="bg-background-100 py-24 md:py-32 px-6">
      <div className="max-w-[1240px] mx-auto">
        <div className="text-center mb-16">
          <p className="text-[10px] tracking-[0.5em] uppercase text-primary-600 mb-4">— Pricing —</p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">料金プラン</h2>
        </div>

        <div className="flex justify-center">

          {/* Plan 1: Event & Shooting */}
          <div className="bg-background-50 rounded-sm border border-background-200 overflow-hidden group max-w-5xl w-full">
            <div className="bg-secondary-100/70 px-8 py-5 border-b border-background-200">
              <div className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <h3 className="font-heading text-lg text-foreground-950 tracking-wide">イベント展示・撮影プラン</h3>
              </div>
            </div>
            <div className="p-8 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">
                <div className="flex items-end justify-between pb-5 border-b border-background-200">
                  <div>
                    <p className="text-[11px] tracking-[0.2em] uppercase text-foreground-500 mb-1">半日</p>
                    <p className="text-xs text-foreground-600">４時間</p>
                  </div>
                  <div className="text-right">
                    <p className="font-heading text-2xl text-foreground-950">¥350,000<span className="text-xs text-foreground-500 font-normal">〜</span></p>
                  </div>
                </div>
                <div className="flex items-end justify-between pb-5 border-b border-background-200">
                  <div>
                    <p className="text-[11px] tracking-[0.2em] uppercase text-foreground-500 mb-1">1日</p>
                    <p className="text-xs text-foreground-600">8時間</p>
                  </div>
                  <div className="text-right">
                    <p className="font-heading text-2xl text-foreground-950">¥500,000<span className="text-xs text-foreground-500 font-normal">〜</span></p>
                  </div>
                </div>
              </div>
              <div className="mt-6 space-y-2">
                <div className="flex items-start gap-2 text-[11px] text-foreground-600 leading-relaxed">
                  <span className="text-secondary-500 mt-0.5 shrink-0">※</span>
                  <span>別途、スタッフ立ち会い費（¥35,000/1名）および積載車搬送費 30km（往復 ¥55,000〜）が発生いたします。その他の場所の場合は要相談になります。</span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
}